<div class="h-full w-full" [ngClass]="{ 'tab-group-with-options-wrapper': enableOptions }">
  @if (mode === 'route') {
    <nav animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start" mat-tab-nav-bar [tabPanel]="tabPanel">
      <a
        *ngFor="let tab of tabs; let i = index"
        cdkDropList
        cdkDropListOrientation="horizontal"
        cdkDropListElementContainer=".mat-mdc-tab-labels"
        mat-tab-link
        [active]="activeLink() === tab.path"
        (click)="navigateToTab(tab.path)"
        (cdkDropListDropped)="drop($event)"
      >
        <input
          [ngClass]="['input-tab-' + i, i !== selectedTabIndex() || !enableRename() ? 'hidden' : '']"
          class="max-w-20 border p-1 focus:border-2 focus:border-primary bg-white"
          [value]="activeTabName()"
          (input)="activeTabName.set($event.target.value)"
          (keydown.enter)="processRenaming($event); $event.preventDefault(); $event.stopPropagation()"
          (blur)="processRenaming($event)"
        />
        <span
          [ngClass]="{ hidden: i === selectedTabIndex() && enableRename() }"
          cdkDrag
          cdkDragRootElement=".mat-mdc-tab"
          cdkDragPreviewClass="drag-preview"
          class="flex flex-row items-center justify-start gap-1.5"
        >
          @if (enableDragging) {
            <ts-icon cdkDragHandle class="drag-indicator" icon="drag_indicator" color="black" />
          }
          <ts-icon class="tab-icon" *ngIf="tab?.icon" [icon]="tab?.icon" color="black" />
          {{ tab?.label }}
        </span>
      </a>
    </nav>
    <mat-tab-nav-panel class="max-h-full h-full min-h-full" #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  } @else {
    <mat-tab-group
      cdkDropList
      cdkDropListOrientation="horizontal"
      cdkDropListElementContainer=".mat-mdc-tab-labels"
      animationDuration="0ms"
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      class="max-h-full h-full min-h-full"
      (cdkDropListDropped)="drop($event)"
      [(selectedIndex)]="selectedTabIndex"
    >
      @for (tab of tabs; track tab.label; let i = $index) {
        <mat-tab>
          <ng-template mat-tab-label>
            <input
              [ngClass]="['input-tab-' + i, i !== selectedTabIndex() || !enableRename() ? 'hidden' : '']"
              class="max-w-20 border p-1 focus:border-2 focus:border-primary bg-white"
              [value]="activeTabName()"
              (input)="activeTabName.set($event.target.value)"
              (keydown.enter)="processRenaming($event); $event.preventDefault(); $event.stopPropagation()"
              (blur)="processRenaming($event)"
            />
            <span
              [ngClass]="{ hidden: i === selectedTabIndex() && enableRename() }"
              cdkDrag
              cdkDragRootElement=".mat-mdc-tab"
              cdkDragPreviewClass="drag-preview"
              class="flex flex-row items-center justify-start gap-1.5"
            >
              @if (enableDragging) {
                <ts-icon cdkDragHandle class="drag-indicator" icon="drag_indicator" color="black" />
              }
              <ts-icon class="tab-icon" *ngIf="tab?.icon" [icon]="tab?.icon" color="black" />
              {{ tab?.label }}
            </span>
          </ng-template>

          <ng-template matTabContent>
            <ng-container *ngTemplateOutlet="tab.template"></ng-container>
          </ng-template>
        </mat-tab>
      }
      @if (enableCreation) {
        <mat-tab disabled>
          <ng-template mat-tab-label>
            <button matTooltip="Add New Tab" class="add-tab" (click)="createNewTab()">
              <ts-icon icon="ts_plus" color="light-gray"></ts-icon>
            </button>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  }

  @if (enableOptions) {
    <ts-menu tabindex="0" class="options-menu" [items]="menuOptions" />
  }
</div>
